import * as React from 'react';
import { storeDispatch } from 'state/Store';
import FileType from 'data/FileType';
import { selectLocalFiles } from 'utils';
import { trackEvent } from 'utils/Tracker';
import { addLocalGraphics } from 'state/actions';
import { OverlayIcon } from 'components/OverlayIcon';
import { computerIconUrl } from 'components/OverlayOptions';

const TextBlock: React.FC<{
  header: React.ReactNode;
  body: React.ReactNode;
}> = props => {
  const { header, body } = props;
  return (
    <div style={{ textAlign: 'left' }}>
      <h2 style={{ fontSize: 24, marginBottom: 8 }}>{header}</h2>
      <div>{body}</div>
    </div>
  );
};

const DesignTool: React.FC<{
  name: string;
  iconURLorNode: string | React.ReactNode;
  url?: string;
  onClick?: () => void;
}> = props => {
  const { name, iconURLorNode, url, onClick } = props;
  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        padding: 8,
        alignItems: 'center'
      }}
      onClick={() => {
        if (url !== undefined) {
          trackEvent('Import design from', { tool: name });
          window.open(url, '_blank');
        }
        if (onClick !== undefined) {
          onClick();
        }
      }}
      className="design-tool"
    >
      {typeof iconURLorNode === 'string' ? (
        <img width={48} height={48} src={iconURLorNode} />
      ) : (
        <div style={{ width: 48, height: 48, transform: 'scale(0.7)' }}>
          {iconURLorNode}
        </div>
      )}

      <h2 style={{ fontSize: 16 }}>{name}</h2>
    </div>
  );
};

export const ImportDesign = () => {
  const pickFile = React.useCallback(async () => {
    trackEvent('Import design from', { tool: 'Single layer' });
    const selectType = FileType.Image;
    const files = await selectLocalFiles(selectType, false);
    if (files.length) {
      storeDispatch(addLocalGraphics(files));
    }
  }, []);
  return (
    <div
      style={{
        maxWidth: 500,
        display: 'flex',
        flexDirection: 'column',
        gap: 32
      }}
      className="import-design"
    >
      <TextBlock
        header={<>Import single image</>}
        body={
          <>
            If you want to animate a single picture, just drag it here or select
            it from your computer.
          </>
        }
      />
      <DesignTool
        name="Select image"
        iconURLorNode={<OverlayIcon imageUrl={computerIconUrl} />}
        onClick={pickFile}
      />
      <TextBlock
        header={<>Or import multiple layers</>}
        body={
          <>
            If you have the source file of a design composition, you can import
            all its layers using our export plugins for these popular Design
            tools:
          </>
        }
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <DesignTool
          name="Adobe Photoshop"
          iconURLorNode="/media/new-screen/import-ps.png"
          url="https://learn.beatflyer.com/photoshop-export"
        />
        <DesignTool
          name="Figma"
          iconURLorNode="/media/new-screen/import-figma.png"
          url="https://www.figma.com/community/plugin/948942429394250406/Beatflyer-Exporter"
        />
        <DesignTool
          name="Sketch"
          iconURLorNode="/media/new-screen/import-sketch.png"
          url="https://github.com/sketchplugins/plugin-directory/blob/master/README.md"
        />
      </div>
      <div style={{ textAlign: 'left' }}>
        For detailed instructions,{' '}
        <a
          href="http://learn.beatflyer.com/import-graphics"
          target="_blank"
          onClick={() => {
            trackEvent('Read design import docs');
          }}
        >
          read the documentation
        </a>
        .
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/onboarding/ImportDesign.tsx